var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop } from 'vue-property-decorator';
import { SearchStatus } from '@/overmind/search/state';
let WithPhones = class WithPhones extends Vue {
};
__decorate([
    Prop({ default: SearchStatus.NOT_RECEIVED })
], WithPhones.prototype, "createSearchState", void 0);
__decorate([
    Prop({ default: '' })
], WithPhones.prototype, "withPhones", void 0);
__decorate([
    Prop({ default: 1 })
], WithPhones.prototype, "page", void 0);
WithPhones = __decorate([
    Component({
        components: {},
    })
], WithPhones);
export default WithPhones;
